export const model = {
    id: null,
    name: '',   
    state_id: '', 
    code: "",

    created_at: '',
    updated_at: ''
};
